import CONSTANTS from '../constants'
import { getRequest, postRequest } from '../../services'
import { APICONFIG } from '../apiConfig'
import { addEventLog } from './EventsLog'

// Calls the API to get EVENT Initials
export const getEventDetails = (eventPayload) => (dispatch) => {
	dispatch(addEventLog(eventPayload, CONSTANTS.EVENT_INITIAL_REQUEST))
	dispatch({ type: CONSTANTS.EVENT_INITIAL_REQUEST })
	const url = APICONFIG.singleEventUrl+'/'+eventPayload?.event_id + '?facility_id='+eventPayload?.facility_id
	return getRequest(url).then((res) => {
		let resObject = { ...eventPayload, ...res }
		dispatch(addEventLog(resObject, CONSTANTS.EVENT_INITIAL_SUCCESS))
		dispatch({ type: CONSTANTS.EVENT_INITIAL_SUCCESS, data: res })
		return res
	}).catch((err) => {
		let errObject = { ...eventPayload, ...err }
		dispatch(addEventLog(errObject, CONSTANTS.EVENT_INITIAL_FAILURE))
		dispatch({ type: CONSTANTS.EVENT_INITIAL_FAILURE })
		return err
	})
}

//pass details	
export const getPassDetails = (postData) => (dispatch) => {
	dispatch(addEventLog(postData, CONSTANTS.PASS_INITIAL_REQUEST))
	dispatch({ type: CONSTANTS.PASS_INITIAL_REQUEST })
	return postRequest(APICONFIG.getPassListUrl, postData).then((res) => {
		let resObject = { ...postData, ...res }
		dispatch(addEventLog(resObject, CONSTANTS.PASS_INITIAL_SUCCESS))
		dispatch({ type: CONSTANTS.PASS_INITIAL_SUCCESS, data: res?.data })
		return res?.data
	}).catch((err) => {
		let errObject = { ...postData, ...err }
		dispatch(addEventLog(errObject, CONSTANTS.PASS_INITIAL_FAILURE))
		dispatch({ type: CONSTANTS.PASS_INITIAL_FAILURE })
	})
}

export const updateEventState = (update) => dispatch => {
	dispatch(addEventLog(update, CONSTANTS.UPDATE_EVENT_STATE))
	dispatch({ type: CONSTANTS.UPDATE_EVENT_STATE, update })
}



// Calls the API to get EVENT Initials
export const getFilteredEventList = (postData) => (dispatch) => {
	let payloadUpdatePass = {...postData, 'device_type': 'web'}
	dispatch(addEventLog(payloadUpdatePass, CONSTANTS.GET_FILTERED_EVENT_DATA_REQUEST))
	dispatch({ type: CONSTANTS.GET_FILTERED_EVENT_DATA_REQUEST })
	return postRequest(APICONFIG.getFilteredEventDataByDate, payloadUpdatePass).then((res) => {
		let resObject = { ...payloadUpdatePass, ...res }
		dispatch(addEventLog(resObject, CONSTANTS.GET_FILTERED_EVENT_DATA_SUCCESS))
		dispatch({ type: CONSTANTS.GET_FILTERED_EVENT_DATA_SUCCESS, data: res?.data })
		return res
	}).catch((err) => {
		let errObject = { ...payloadUpdatePass, ...err }
		dispatch(addEventLog(errObject, CONSTANTS.GET_FILTERED_EVENT_DATA_FAILURE))
		dispatch({ type: CONSTANTS.GET_FILTERED_EVENT_DATA_FAILURE })
		return err
	})
}

export const getMonthEventList = (postData) => (dispatch) => {
	let payloadUpdatePass = {...postData, 'device_type': 'web'}
	dispatch(addEventLog(payloadUpdatePass, CONSTANTS.GET_FILTERED_EVENT_DATA_REQUEST))
	dispatch({ type: CONSTANTS.GET_FILTERED_EVENT_DATA_REQUEST })
	return postRequest(APICONFIG.getEventListUrl, payloadUpdatePass).then((res) => {
		let resObject = { ...payloadUpdatePass, ...res }
		dispatch(addEventLog(resObject, CONSTANTS.GET_FILTERED_EVENT_DATA_SUCCESS))
		dispatch({ type: CONSTANTS.GET_FILTERED_EVENT_DATA_SUCCESS, data: res?.data })
		return res
	}).catch((err) => {
		let errObject = { ...payloadUpdatePass, ...err }
		dispatch(addEventLog(errObject, CONSTANTS.GET_FILTERED_EVENT_DATA_FAILURE))
		dispatch({ type: CONSTANTS.GET_FILTERED_EVENT_DATA_FAILURE })
		return err
	})
}